import React, { useEffect, useMemo, useState } from 'react'
import RemoveModal from '../../common/RemoveModal';
import Select from 'react-select';
import { createAndUpdateDocumentApplicationApi, deleteUserDocsApplicationApi, deleteUserUploadDocumentApi, getCategoryFeildDataApi, getDocsCategoryByTypeApi, getDocsCategorytypeApi, getDocumentByCategoryIdApi, getFormApi, getFormDataByIdApi, getUserFilledFormApi, updateFormStatusApi, uploadImage } from '../../../utils/ApiEndpointFunctions';
import { Link, useParams } from 'react-router-dom';
import Attachment from '../../common/Attachment';
import toast from 'react-hot-toast';
import { applicationFeildRowData, updateFormStatusInitialValues, updateFormStatusValidationSchema } from '../../common/Validation'
import CommonTable from '../../common/table/CommonTable';
import { useFormik } from 'formik';
import Spinwheel from '../../common/Spinwheel';
import { ImageUrl } from '../../../utils/BaseUrl';
import ReactDatePicker from 'react-datepicker';
import CreatableSelect from 'react-select/creatable';
import UpdateFormStatusModal from './UpdateFormStatusModal';

const FormFeildRender = ({ ele, formik, docSpin, handlefile }) => {

  const addOrRemovePhone = (ind, buttonType) => {
    if (buttonType === "plus") {
      formik.setFieldValue(ele.name, [...formik.values[ele.name], ele.feilds])
    } else if (buttonType === "minus") {
      formik.setFieldValue(ele.name, formik.values[ele.name]?.filter((_, i) => i !== ind))
    }
  }


  if (ele.type === "date") console.log(formik.values[ele.name])
 
  switch (ele.type) {
    case "input":
      if (ele.inputType === "file") {
        return <div key={ele.name}>
          <div className='d-flex'>
            <label htmlFor={ele?.name} className="form-label">{ele.label}</label>
          </div>
          <div className="position-relative">
            <div className='row'>
              <div className='col-9'>
                <Attachment formik={formik} docSpin={docSpin} feildName={ele.name} handlefile={(e) => { handlefile(e, formik, ele.name) }} />
                {formik?.touched?.[ele?.name] && formik?.errors?.[ele?.name] ? (<div className='req-error'>{formik?.errors?.[ele?.name]}</div>) : null}
              </div>
              <div className='col-3' style={{height: "90px"}}>
                <a href={formik?.values?.[ele.name] ? ImageUrl + formik?.values?.[ele.name] : "/images/person-circle.svg"} className='me-2 ms-2' target="_blank" rel="noopener noreferrer">
                  <img
                    src={formik?.values?.[ele.name] ? ImageUrl + formik?.values?.[ele.name] : "/images/person-circle.svg"}
                    style={{
                      height: '100%',
                      width: "100%",
                      cursor: 'pointer',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                  />
                </a>
              </div>
            </div>
           
           
          </div>
        </div>
      } else {

        if (formik.values?.["nationlityType"] === "thai" && (ele.name === "passportNumber" || ele.name === "nationality")) return null;
        if (formik.values?.["nationlityType"] === "foreigner" && ele.name === "thaiNationalIdNo") return null;

        return <div key={ele.name}>
          <div className='d-flex'>
            <label htmlFor={ele.name} className="form-label">{ele.label}</label>
          </div>
          <div className="position-relative">
            <input className="form-control border border-1" type="text" id={ele.name} placeholder="Enter" name={ele.name} value={formik.values?.[ele.name]} onChange={formik.handleChange} onBlur={formik.handleBlur} />

            {formik.touched?.[ele.name] && formik.errors?.[ele.name] ? (<div className='req-error'>{formik.errors?.[ele.name]}</div>) : null}
          </div>
        </div>
      }
    case "textarea":
      return <textarea className="form-control" placeholder={ele.placeholder} />
    case "select":
      return <div>
        <div className='d-flex'>
          <label htmlFor={ele?.name} className="form-label">{ele.label}</label>
        </div>
        <select className="form-control border border-2" placeholder={ele.placeholder} id={ele.name} name={ele.name} value={formik.values?.[ele.name]} onChange={formik.handleChange} onBlur={formik.handleBlur} >
          {ele.options.map((item) => <option key={item.value} value={item.value}>{item.name}</option>)}
        </select>
      </div>

    case 'react-select' :

      return <div className="">
        <label
          className="form-label text-start d-block"
          htmlFor="size"
        >
          {ele.label}
        </label>
        <CreatableSelect
          isMulti={ele.isMulti}
          options={ele.options}
          name="colors"
          value={ele.isMulti ? formik.values?.[ele?.name]?.map(ele => ({ label: ele, value: ele })) : { label: formik.values?.[ele?.name], value: formik.values?.[ele?.name] }}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={(e) => {

            formik.setFieldValue(ele?.name, e?.map?.(ele => ele.value));
          }}
        />
      </div>

    case 'date' :
      return <div>
        <label htmlFor="dob" className="form-label">{ele.label}</label>
        <div className="position-relative">
          <ReactDatePicker
            selected={formik.values?.[ele.name] ? new Date(formik.values?.[ele.name]) : ""}
            name={ele.name}
            id={ele.name}
            onChange={(e) => {
              e ?
                formik.setFieldValue(ele.name, e) :
                formik.setFieldValue(ele.name, "")
            }}
            onBlur={formik.handleBlur}
            className='form-control w-100 border border-1'
            placeholderText='Select'
            autoComplete="off"
            dateFormat={"dd/MM/yyyy"}
            maxDate={new Date()}
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar input-icon" viewBox="0 0 16 16">
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
          </svg>

          {formik.touched.dob && formik.errors.dob ? (<div className='req-error'>{formik.errors.dob}</div>) : null}
        </div>
      </div>
    case 'list' : 

      
      if (ele.name === "referenceData" ) {
        return <div>
          <hr />
          <label htmlFor="phone" className="form-label">{ele.label}</label>
          {formik.values?.[ele.name]?.map?.((ele1, ind2) => {
          
            return <div key={ind2} className="position-relative mb-2">
              {/* <input className="form-control border border-1" type="tel" id="phone" placeholder="Enter your phone number" name={`phone[${index}]`} value={formik.values?.phone?.[index]} onChange={formik.handleChange} onBlur={formik.handleBlur} /> */}
              <div className="row row-cols-2">
                <div className="position-relative">
                  <input className="form-control border border-1" type="text" id={ele.name} placeholder="Enter" name={`${ele.name}[${ind2}].name`} value={formik.values?.[ele.name]?.[ind2]?.name} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                  {formik.touched?.[ele.name] && formik.errors?.[ele.name] ? (<div className='req-error'>{formik.errors?.[ele.name]}</div>) : null}
                </div>
                <div className="position-relative">
                  <Attachment formik={formik} docSpin={docSpin} feildName={ele.name} filePosition={ind2} fileName='file' handlefile={(e) => { handlefile(e, formik, `${ele.name}[${ind2}].file`) }} />
                  {formik?.touched?.[ele?.name] && formik?.errors?.[ele?.name] ? (<div className='req-error'>{formik?.errors?.[ele?.name]}</div>) : null}
                </div>
              </div>              
                
              {formik?.values?.[ele.name]?.length - 1 === ind2 && formik?.values?.[ele.name]?.length < 5 && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style={{ position: "absolute", right: Boolean(formik?.values?.phone?.length - 1) ? '-50px' : "-25", top: "15px" }} class="bi bi-plus-square" viewBox="0 0 16 16" onClick={() => { addOrRemovePhone(ind2, "plus") }}>
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg>}
              {Boolean(formik?.values?.[ele.name]?.length - 1) && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style={{ position: "absolute", right: '-25px', top: "15px" }} class="bi bi-dash-square" viewBox="0 0 16 16" onClick={() => { addOrRemovePhone(ind2, "minus") }}>
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
              </svg>}
              {formik.touched?.phone?.[ind2] && formik.errors?.phone?.[ind2] ? (<div className='req-error'>{formik.errors?.phone?.[ind2]}</div>) : null}
              <div className="d-flex justify-content-end ">
                <div>
                </div>
              </div>
            </div>
          })}
        </div>
      }
   

    default:
      return null
  }
}


function DocumentApplicationTable() {
  const [categoryType, setCategoryType] = useState([]);
  const [category, setCategory] = useState([])
  const [selectCategory, setSelectedCategory] = useState({});
  const [selectType, setSelectType] = useState({})
  const params = useParams();
  const [categoryFeildData, setCategoryFeildData] = useState([]);
  const [id, setId] = useState(params?.id)
  const [docSpin, setDocSpin] = useState(true);
  const [updateFormLoading, setUpdateFromLoading] = useState(false)
  const [tableHeader, setTableHeader] = useState([
    { key: "index", name: "S.No" },
    { key: "category", name: "Category" },
    { key: "name", name: "Name" },
    { key: "status", name: "Status" },
    { key: "file", name: "File" }
  ])
  const formStatusChangeModalId = "formStatusChangeModalId"
  const [tableRowData, setTableRowData] = useState([])
  const [addDocLoader, setAddDocLoader] = useState(false)
  const [removeData, setRemoveData] = useState({});

  const getDocsCategorytype = async () => {
   try {
     const res = await getDocsCategorytypeApi();
     if (res.status === 200) {
   
       const resultedData = res.data?.data?.types?.map(ele => ({label:ele.type,value:ele.type}))
       setCategoryType(resultedData);
       setSelectType(resultedData[0]);

     }
   } catch (error) {
    console.log(error)
   }
  }

  const getDocsCategory = async (data) => {
    try {
      const res = await getDocsCategoryByTypeApi(data.label);
      if (res.status === 200) {
        const category = res.data?.data?.categories
        const resultData = category?.map(ele => ({label: ele.name, value: ele}))
        setCategory(resultData)

        let isExistCategory = category.find((ele) => {
          if (selectCategory?.labelId === ele?.labelId) {
            return true
          } else {
            return false
          }
        })

        if(isExistCategory) {
          setSelectedCategory(isExistCategory)
        } else {
          setSelectedCategory(resultData[0].value)
        }

      }
    } catch (error) {
      console.log(error)
    }
  }


  const typeSelectHandler = (data, type) => {
    if(type === "type") setSelectType(data)
     setSelectedCategory(data.value)
  }

  const handlefile = async (e, formik, feildName) => {
    try {
      const file = e.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", 2)
        formData.append("folder", "document")
        const res = await uploadImage('/users/fileUpload', formData)
        if (res.status === 200 && res.data?.status === 1) {
          formik.setFieldValue(feildName, res.data?.data?.fileName)
          toast.success("File uploaded")
        }
      }
    } catch (error) {
      console.log(error)
    }
  }  

  const formUpdateFormik = useFormik({
    initialValues: updateFormStatusInitialValues,
    validationSchema: updateFormStatusValidationSchema,
    onSubmit: async (values) => {
      try {
        setUpdateFromLoading(true);
        const res = await updateFormStatusApi(values);
        if(res.status === 200) {
          toast.success(res.data?.message);
          document.getElementById(formStatusChangeModalId).click();
          getUserFilledDocument();
        }
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message || "Something went wrong")
      }
      setUpdateFromLoading(false);
    },
    enableReinitialize: true,
  })

 

  const getDocumentByCategoryId = async () => {
    try {
      setDocSpin(true)
      const res = await getFormApi(id, selectCategory?.type, selectCategory?.name);
      if (res.status === 200) {
   
        tableRowDataHandler(res.data?.data)
      }
     
    } catch (error) {
      console.log(error)
    }
    setDocSpin(false)
  }

  const getUserFilledDocument = async () => {
    try {
      setDocSpin(true)
      const res = await getUserFilledFormApi(id);
      if (res.status === 200) {
        tableRowDataHandler(res.data?.data)
      
      }

    } catch (error) {
      console.log(error)
    }
    setDocSpin(false)
  }

  const removeHandler = async () => {
    try {
      const res = await deleteUserDocsApplicationApi(removeData?._id);
      if (res.status === 200) {
        toast.success(res.data?.message)
        getUserFilledDocument();
      }
    } catch (error) {
      console.log(error)
      toast.error("Something went wrong")
    }
  }

  

  useEffect(() => {
    if(id) {
      getDocsCategorytype();
      getUserFilledDocument()
    }

  }, [id])

  useEffect(() => {
    if(selectType.label) {
      getDocsCategory(selectType)
     
    }
  }, [selectType])


 

  const formSubmitHandler = async (values) => {
    try {
      const payload = { ...values, userId: id, Category: selectCategory?.type, form: selectCategory?.name, categoryId: selectCategory?._id }

      setAddDocLoader(true)
      const res = await createAndUpdateDocumentApplicationApi(payload)
      if(res.status === 200) {
        toast.success(res.data?.message)
        getUserFilledDocument();
        document.getElementById("ManageStatusModal")?.click();
      }
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message, "Something went wrong")
    }
    setAddDocLoader(false)
  }

  const formFormik = useFormik({
    initialValues: applicationFeildRowData[selectCategory.name]?.initialValue,
    validationSchema: applicationFeildRowData[selectCategory.name]?.validation,
    enableReinitialize: true,
    onSubmit: formSubmitHandler
  })

 



  useEffect(() => {
    if(selectCategory?.name) {  
      const currenFeilds = applicationFeildRowData[selectCategory?.name]?.feilds
      setCategoryFeildData(currenFeilds)
     
      // setTableHeader([...(currenFeilds ? (currenFeilds?.map?.(ele => {
      //   if(ele.type === "list") return null
      //   return {key: ele.name, name: ele.label}
      // })).filter(Boolean): []), {key: "action", name: ""}])

      // getDocumentByCategoryId()

    }
  },[selectCategory])

  function tableRowDataHandler(arr = []) { 
    try {
      // const currenFeilds = applicationFeildRowData[selectCategory?.name].feilds;


      // const result = arr?.map?.(ele => {
      //   let obj = {};


      //    currenFeilds?.forEach((el,index, ar) => {
         
      //     if(el.type === 'list') return null
      //     if(el.inputType === "file") {
      //       obj[el.name] = <div className='position-relative'>
      //         {ele?.[el.name] ? (
      //           <div className="tooltip1">
      //             <Link to={ImageUrl + ele?.[el.name]} target="__blank">{ele?.[el.name]?.split("/")[1]?.substr?.(0, 20)}...</Link>
      //             <div className='wrapper'>
      //               <div className="tooltip1-text">{ele?.[el.name]?.split("/")[1]}</div>
      //             </div>
      //           </div>
      //         ) : (
      //           "-"
      //         )}
      //       </div>
      //     } else {
      //       obj[el.name] = <div className='position-relative'>
      //         {ele?.[el.name] ? (
      //           <div className="tooltip1">
      //             <td>{ele?.[el.name]?.substr?.(0, 20)}</td>
      //             <div className='wrapper'>
      //               <div className="tooltip1-text">{ele?.[el.name]}</div>
      //             </div>
      //           </div>
      //         ) : (
      //           "-"
      //         )}
      //       </div>
      //     }         
      //   }) 

      //   return obj
      // })

      // setTableRowData(result)

      const getFormDataByCateogoryId = async (ele) => {
        try {

          const res = await getFormDataByIdApi(ele._id, id)
          if(res.status === 200) {
            console.log(res.data?.data)
            formFormik.setValues(res.data?.data)

          }

        } catch (error) {
          console.log(error)
          // toast.success(error?.response?.data?.message || "Something went wrong")
        }
      }

      const formSelectionHandler = (ele) => {
        console.log(ele)
        typeSelectHandler({ label: ele?.applyDocsCategoryId?.name, value: ele?.applyDocsCategoryId }, "category");
        setSelectType({ label: ele?.applyDocsCategoryId?.type, value: ele?.applyDocsCategoryId?.type });
        getFormDataByCateogoryId(ele)
      }

      

      const result = arr?.map?.((ele, index) => {
        console.log(ele.file)
        return {
          index: index + 1,
          category: ele?.applyDocsCategoryId?.type,
          name: <div data-bs-toggle="modal" data-bs-target={`#ManageStatusModal`} className='text-primary' style={{ cursor: "pointer" }} onClick={() => { formSelectionHandler(ele) }}>{ele?.applyDocsCategoryId?.name}</div>,
          status: <div data-bs-toggle="modal" data-bs-target={`#${formStatusChangeModalId}`} className='text-primary' style={{ cursor: "pointer" }} onClick={() => { formUpdateFormik.setValues({_id: ele._id, status: ele.status, file: ele.file}) }}>{ele.status || "-"}</div>,
          file: ele.file ? <Link to={ImageUrl + ele.file} target="_blank" >{ele.file}</Link> : ""
        }
      })

      setTableRowData(result)

    } catch (error) {
      console.log(error)
    }
  }

  
  return (
    <><div className="card p-3  table-responsive" style={{ minHeight: "400px" }} >

      <div className='d-flex justify-content-between'>
        <div className='d-flex gap-3'>
          {/* <div className="" style={{ minWidth: "250px" }}>
            <Select
              className="basic-single mb-2 w-100"
              classNamePrefix="select"
              isSearchable
              value={selectType?.label ? selectType : null}
              options={categoryType}
              onChange={(ele) => { typeSelectHandler(ele, "type") }}            />
          </div>
          <div className="" style={{ minWidth: "250px" }}>
            <Select
              className="basic-single mb-2 w-100"
              classNamePrefix="select"           
              isSearchable
              value={selectCategory ? { value: selectCategory, label: selectCategory?.name } : null}
              options={category}
              onChange={(ele) => { typeSelectHandler(ele, "category") }}
            />
          </div> */}
        </div>
        <div data-bs-toggle="modal" data-bs-target={`#ManageStatusModal`} onClick={formFormik.resetForm} className="btn-custom w-auto ms-0 mt-0 mb-3 " >Add</div>
      </div>
      <hr />

      <CommonTable headers={tableHeader} data={tableRowData} loading={docSpin}  />

      <div className="modal fade" id="ManageStatusModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button type="button" className="btn-close block-close" data-bs-dismiss="modal" aria-label="Close" ></button>
            </div>
            <div className="modal-body ">
              <div className="col-lg-12" style={{ zIndex: "1" }}>
                <form action="" className='p-4' onSubmit={formFormik.handleSubmit} >
                  <h2 style={{ textAlign: "left" }}>
                    Document form
                  </h2>                  
                  <div className="row">  

                    <div className="" style={{ minWidth: "250px" }}>
                      <Select
                        className="basic-single mb-2 w-100"
                        classNamePrefix="select"
                        isSearchable
                        value={selectType?.label ? selectType : null}
                        options={categoryType}
                        onChange={(ele) => { typeSelectHandler(ele, "type") }} />
                    </div>
                    <div className="" style={{ minWidth: "250px" }}>
                      <Select
                        className="basic-single mb-2 w-100"
                        classNamePrefix="select"
                        isSearchable
                        value={selectCategory ? { value: selectCategory, label: selectCategory?.name } : null}
                        options={category}
                        onChange={(ele) => { typeSelectHandler(ele, "category") }}
                      />
                    </div>                  
                    {categoryFeildData?.map((ele) => {                    
                      return <FormFeildRender ele={ele} handlefile={handlefile} formik={formFormik} docSpin={docSpin}  />
                    })}
                  </div>
                  <div className="modal-footer border-0 justify-content-center pt-4">
                    <button type="submit" className="btn-custom w-auto" disabled={addDocLoader}   >{addDocLoader ? <Spinwheel sizeClass="spin-small" /> : "Submit"}</button>
                    <button type="button" className="btn-custom w-auto" data-bs-dismiss='modal' >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UpdateFormStatusModal loading={false} modalId={formStatusChangeModalId} formik={formUpdateFormik} handlefile={handlefile} />
      <RemoveModal removeHandler={removeHandler} modalId="removedoc" message={<>Are you sure you want to<br /> remove this?</>} />
    </div></>
  )
}

export default DocumentApplicationTable